import type { GetMyFantasyLeaguesQuery, SearchFantasyLeaguesQuery } from '../../../../types/graphql-generated';
import type { FantasyLeagueCardData } from './types';

type MemberItem = NonNullable<GetMyFantasyLeaguesQuery['userAccount']>['fantasyLeagueMembers'][number];
type SearchLeagueItem = SearchFantasyLeaguesQuery['searchFantasyLeagues']['leagues'][number];

export function mapMemberToCardData(member: MemberItem): FantasyLeagueCardData {
  const { fantasyLeague, unreadActivityCount } = member;
  return {
    id: fantasyLeague.id,
    name: fantasyLeague.name,
    isPublic: fantasyLeague.isPublic,
    participantsCount: fantasyLeague.participantsCount,
    image: fantasyLeague.image,
    updatedAt: fantasyLeague.updatedAt,
    creator: fantasyLeague.creator
      ? { id: fantasyLeague.creator.id, fullName: fantasyLeague.creator.fullName }
      : null,
    unreadActivityCount,
  };
}

export function mapSearchLeagueToCardData(league: SearchLeagueItem): FantasyLeagueCardData {
  return {
    id: league.id,
    name: league.name,
    isPublic: league.isPublic,
    participantsCount: league.participantsCount,
    image: league.image,
    updatedAt: league.updatedAt,
    creator: league.creator
      ? { id: league.creator.id, fullName: league.creator.fullName }
      : null,
    // unreadActivityCount intentionally omitted: user is not a member yet
  };
}
